(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2562],{

/***/ 72562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ab_cards_slider_src; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../node_modules/react-in-viewport/dist/es/index.js
var es = __webpack_require__(28447);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var ab_text_src = __webpack_require__(145);
// EXTERNAL MODULE: ../packages/ab-link/src/index.tsx
var ab_link_src = __webpack_require__(276);
// EXTERNAL MODULE: ../packages/ab-paragraph-text/src/index.tsx
var src = __webpack_require__(2569);
// EXTERNAL MODULE: ../packages/ab-functions/src/index.tsx + 9 modules
var ab_functions_src = __webpack_require__(5134);
// EXTERNAL MODULE: ../node_modules/numeral/numeral.js
var numeral = __webpack_require__(94960);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 38 modules
var esm = __webpack_require__(52257);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ../packages/ab-context-ebox/src/index.tsx + 3 modules
var ab_context_ebox_src = __webpack_require__(13757);
// EXTERNAL MODULE: ../packages/ab-cards-slider/src/ab-card.scss
var ab_card = __webpack_require__(41504);
;// CONCATENATED MODULE: ../packages/ab-cards-slider/src/CardEBox.tsx






var Card = function(param) {
    var src = param.src, srcSet = param.srcSet, label = param.label, href = param.href, title = param.title, description = param.description, link = param.link, cardsLength = param.cardsLength;
    // console.log("Card", href, link);
    var ref = (0,_sliced_to_array/* default */.Z)((0,ab_context_ebox_src/* useEboxContext */.OI)(), 2), stateEbox = ref[0], dispatchEbox = ref[1];
    var itemsEbox = stateEbox.itemsEbox;
    var resetEbox = dispatchEbox.resetEbox;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card-slider".concat(cardsLength > 3 ? " four-cards" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                href: href || (link === null || link === void 0 ? void 0 : link.url),
                onClick: function() {
                    if (itemsEbox === null || itemsEbox === void 0 ? void 0 : itemsEbox.length) {
                        resetEbox();
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    srcSet: srcSet,
                                    media: "(max-width: 850px)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: src,
                                    loading: "lazy",
                                    alt: label || title
                                })
                            ]
                        })
                    }),
                    label ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "h1",
                        children: label
                    }) : null,
                    title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "h1",
                        className: "title",
                        children: title
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "span",
                        className: "description",
                        children: description
                    })
                ]
            }),
            link && (link === null || link === void 0 ? void 0 : link.title) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, {
                prefetch: false,
                text: (link === null || link === void 0 ? void 0 : link.title) || "Descubrir",
                href: (link === null || link === void 0 ? void 0 : link.href) || (link === null || link === void 0 ? void 0 : link.url),
                target: link.target,
                style: {
                    width: "fit-content"
                }
            }) : null
        ]
    });
};
/* harmony default export */ var CardEBox = (Card);

// EXTERNAL MODULE: ../packages/ab-cards-slider/src/ab-cards-slider.scss
var ab_cards_slider = __webpack_require__(68352);
;// CONCATENATED MODULE: ../packages/ab-cards-slider/src/index.tsx













var CardsSlider = function(param) {
    var title = param.title, text = param.text, _cards = param.cards, cards = _cards === void 0 ? [] : _cards, _className = param.className, className = _className === void 0 ? "" : _className, _classname = param.classname, classname = _classname === void 0 ? "" : _classname, link = param.link, animated = param.animated, linkBefore = param.linkBefore, linkbefore = param.linkbefore, textStyle = param.textStyle, i18n = param.i18n, navlink = param.navlink, product = param.product;
    var ref, ref1, ref2, ref3;
    var myRef = (0,react.useRef)();
    var esSinAlojamiento = !(product === null || product === void 0 ? void 0 : (ref = product.configuradorEbox) === null || ref === void 0 ? void 0 : (ref1 = ref.estancias) === null || ref1 === void 0 ? void 0 : ref1.length);
    ;
    var t = (0,esm/* useTranslation */.$G)().t;
    var precio = esSinAlojamiento && ((product === null || product === void 0 ? void 0 : product.price) || (product === null || product === void 0 ? void 0 : (ref2 = product.producto) === null || ref2 === void 0 ? void 0 : ref2.price)) ? numeral_default()((product === null || product === void 0 ? void 0 : product.price) || (product === null || product === void 0 ? void 0 : (ref3 = product.producto) === null || ref3 === void 0 ? void 0 : ref3.price)).format("1,000[.]00$") : null;
    var ref4 = (0,es/* useInViewport */.NM)(myRef, {
        threshold: 0.5
    }, {
        onEnterViewport: function() {
        // console.log("entered viewport");
        }
    }, {
        disconnectOnLeave: false
    }), inViewport = ref4.inViewport, enterCount = ref4.enterCount, leaveCount = ref4.leaveCount;
    var handleScroll = function() {
        var element = document.getElementById("menu-#".concat(navlink));
        var menu = document.getElementById("history-menu");
        if (element) {
            if (inViewport) {
                var ref;
                if (!(element === null || element === void 0 ? void 0 : (ref = element.classList) === null || ref === void 0 ? void 0 : ref.contains("selected"))) {
                    var children = menu === null || menu === void 0 ? void 0 : menu.querySelectorAll("li");
                    children.forEach(function(e) {
                        if (e.id !== element.id) {
                            e === null || e === void 0 ? void 0 : e.classList.remove("selected");
                            e === null || e === void 0 ? void 0 : e.classList.add("not-selected");
                        }
                    });
                    element === null || element === void 0 ? void 0 : element.classList.add("selected");
                    element === null || element === void 0 ? void 0 : element.classList.remove("not-selected");
                    menu.scrollLeft = (element === null || element === void 0 ? void 0 : element.offsetLeft) - 10;
                }
            } else {
                var ref1;
                if (!(element === null || element === void 0 ? void 0 : (ref1 = element.classList) === null || ref1 === void 0 ? void 0 : ref1.contains("not-selected"))) {
                    element === null || element === void 0 ? void 0 : element.classList.remove("selected");
                    element === null || element === void 0 ? void 0 : element.classList.add("not-selected");
                }
            }
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        inViewport
    ]);
    (0,react.useEffect)(function() {
        var slider = document.querySelector("#cards-slider-".concat(navlink));
        var cardsContainer = document.querySelector("#cards-container-".concat(navlink));
        var myBar = document.querySelector("#myBar-".concat(navlink));
        var myBarContainer = document.querySelector("#indicator-container-".concat(navlink));
        // const circle = document.querySelector('#circle');
        var isDown = false;
        var startX;
        var scrollLeft;
        if (slider) {
            slider.addEventListener("mousedown", function(e) {
                isDown = true;
                slider.classList.add("active");
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener("mouseleave", function() {
                isDown = false;
                slider.classList.remove("active");
            });
            slider.addEventListener("mouseup", function() {
                isDown = false;
                slider.classList.remove("active");
                slider.classList.remove("prevent-clic");
            });
            slider.addEventListener("mousemove", function(e) {
                if (!isDown) return;
                e.preventDefault();
                slider.classList.add("prevent-clic");
                var x = e.pageX - slider.offsetLeft;
                var walk = x - startX; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
                if (myBar && myBarContainer) {
                    var percent = slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);
                    var percentScroll = myBarContainer === null || myBarContainer === void 0 ? void 0 : myBarContainer.clientWidth;
                    myBar.style.left = "".concat(percent * percentScroll, "px");
                }
            });
            slider.addEventListener("mouseover", function(e) {});
            var computedStyle = getComputedStyle(cardsContainer);
            var elementWidth = cardsContainer.clientWidth; // width with padding
            elementWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
            ;
            ;
            if (elementWidth >= (slider === null || slider === void 0 ? void 0 : slider.scrollWidth)) {
                myBarContainer.style.display = "none";
            // alert(cardsContainer?.clientWidth)
            // setAttribute('display', 'none')
            }
        }
    // document.addEventListener('mousemove', (e) => {
    }, [
        navlink
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "reference",
                style: {
                    top: -100
                },
                id: navlink
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ab-cards-slider ".concat(className || "", " ").concat(classname || ""),
                id: "cards-container-".concat(navlink),
                ref: myRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                element: "h2",
                                animated: animated,
                                style: textStyle,
                                children: title
                            }),
                            precio && navlink == "que-incluye" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                                element: "span",
                                className: "disponible gold",
                                style: {
                                    alignSelf: "center",
                                    fontSize: 20,
                                    fontFamily: "GT Eesti",
                                    fontWeight: 300
                                },
                                children: "".concat(t("total"), " ").concat(precio)
                            }) : null
                        ]
                    }),
                    text ? /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* default */.Z, {
                        text: [
                            text
                        ],
                        singleColumn: true
                    }) : null,
                    link && (linkBefore || linkbefore) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        prefetch: false
                    }, link), {
                        className: "before"
                    })) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        id: "cards-slider-".concat(navlink),
                        children: [
                            cards.map(function(itm, index) {
                                var ref, ref1;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(CardEBox, {
                                    src: (itm === null || itm === void 0 ? void 0 : itm.src) || (itm === null || itm === void 0 ? void 0 : (ref = itm.image) === null || ref === void 0 ? void 0 : ref.mediaItemUrl),
                                    srcSet: (itm === null || itm === void 0 ? void 0 : itm.srcSet) || (itm === null || itm === void 0 ? void 0 : (ref1 = itm.imagemobile) === null || ref1 === void 0 ? void 0 : ref1.mediaItemUrl),
                                    label: itm === null || itm === void 0 ? void 0 : itm.label,
                                    title: itm === null || itm === void 0 ? void 0 : itm.title,
                                    description: itm.description,
                                    href: (0,ab_functions_src/* getTranslation */.i0)({
                                        link: itm.page
                                    }, "uri", {
                                        code: i18n.language.toUpperCase()
                                    }) || itm.href,
                                    link: itm === null || itm === void 0 ? void 0 : itm.link,
                                    cardsLength: navlink == "alojamiento" ? 3 : cards === null || cards === void 0 ? void 0 : cards.length,
                                    index: index
                                }, "cross-card-".concat(index));
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "scroll-indicator",
                                id: "indicator-container-".concat(navlink),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "scroll-indicator-bar",
                                    id: "myBar-".concat(navlink)
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ab_cards_slider_src = (CardsSlider);


/***/ }),

/***/ 2569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41257);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__);




var ParagraphText = function(param) {
    var _text = param.text, text = _text === void 0 ? [] : _text, singleColumn = param.singleColumn, className = param.className, content = param.content, noPlus = param.noPlus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewMore = ref9[0], setViewMore = ref9[1];
    // console.log("ParagraphText", content, text);
    var parsedHtml = content ? (ref8 = (ref7 = (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = content === null || content === void 0 ? void 0 : content.replace(/<div>/g, "<p>")) === null || ref === void 0 ? void 0 : ref.replace(/<\/div>/g, "</p>")) === null || ref1 === void 0 ? void 0 : ref1.replace(/<div class/g, "<p class")) === null || ref2 === void 0 ? void 0 : ref2.replace(/<ul>/g, "<p><ul>")) === null || ref3 === void 0 ? void 0 : ref3.replace(/<\/ul>/g, "</ul></p>")) === null || ref4 === void 0 ? void 0 : ref4.replace(/<p>/g, "")) === null || ref5 === void 0 ? void 0 : ref5.replace(/\n/g, "")) === null || ref6 === void 0 ? void 0 : ref6.replace(/\r/g, "")) === null || ref7 === void 0 ? void 0 : ref7.split("</p>")) === null || ref8 === void 0 ? void 0 : ref8.filter(function(e) {
        return e;
    }) : [];
    // console.log("ParagraphText - content", content);
    // console.log("ParagraphText - parsedHtml", parsedHtml);
    // console.log("ParagraphText - text", text);
    if (text.length == 0 && parsedHtml.length == 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-paragraph-text ".concat(className || "", " ").concat(viewMore ? "full" : ""),
        style: {
            // height: maxHeight,
            columnCount: singleColumn ? undefined : 2,
            display: singleColumn ? "flex" : "block",
            columnGap: singleColumn ? undefined : 36,
            columnFill: singleColumn ? undefined : "balance"
        },
        children: [
            parsedHtml === null || parsedHtml === void 0 ? void 0 : parsedHtml.map(function(itm, index) {
                if (!itm) {
                    return null;
                }
                if (noPlus) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "no-plus show",
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (index == 0 || parsedHtml.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? parsedHtml.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || parsedHtml.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (parsedHtml.length > 1 && index == parsedHtml.length - 1) {
                    ;
                    if (itm.startsWith("<")) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: itm
                            }
                        });
                    } else {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            onClick: viewMore ? function() {
                                return setViewMore(!viewMore);
                            } : null,
                            id: viewMore ? "less" : undefined,
                            className: viewMore && (itm === null || itm === void 0 ? void 0 : itm.includes("<ul>")) ? "less" : "",
                            children: itm
                        }, "paragraph-text-".concat(index));
                    }
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            }),
            text === null || text === void 0 ? void 0 : text.filter(function(e) {
                return e;
            }).map(function(itm, index) {
                if (index == 0 || text.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? text.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || text.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (text.length > 1 && index == text.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParagraphText);


/***/ }),

/***/ 41504:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68352:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41257:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);